function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_44",
  "data-name": "Trazado 44",
  d: "M118.61,8.827A2.5,2.5,0,0,0,117.817,7a5.57,5.57,0,0,0,.162-1.322A5.674,5.674,0,1,0,106.785,7a2.523,2.523,0,0,0,1.283,4.311l3.646,9.8a.63.63,0,0,0,1.182,0l3.646-9.8A2.526,2.526,0,0,0,118.61,8.827ZM109.374,11.2a2.53,2.53,0,0,0,1.04-.708,2.517,2.517,0,0,0,3.783,0,2.54,2.54,0,0,0,.587.492l-4.191,3.492Zm2.931,7.881-1.246-3.351,3.612-3.01Zm3.783-8.994a1.262,1.262,0,0,1-1.261-1.261.63.63,0,0,0-1.261,0,1.261,1.261,0,0,1-2.522,0,.63.63,0,1,0-1.261,0,1.261,1.261,0,1,1-1.94-1.063.631.631,0,0,0,.263-.727,4.418,4.418,0,1,1,8.39,0,.63.63,0,0,0,.263.727,1.258,1.258,0,0,1-.67,2.324Z",
  transform: "translate(-106)",
  fill: "#fff"
});

function SvgIceCream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ice-cream",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.61,
    height: 21.521,
    viewBox: "0 0 12.61 21.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCream);
export default __webpack_public_path__ + "static/media/ice-cream.12d6b960.svg";
export { ForwardRef as ReactComponent };